import React, { Component, useState } from "react";
import { connect } from "react-redux";
import { getDecks, updateHeaderInfo, deRegister, getUserDetails } from "../actions";
import { SaspButton, CopyrightWidget, AILegalStatementCard } from "../components";
import { Divider, Typography, Grid } from "@material-ui/core";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { deviceData, getPastThreeYearsArr, remoteURL, getSASPFacultyURI, setContainer, APPVERSION, getThisYear, scrollTop, hasLegal } from "../common";
import { Link } from "react-router-dom";
import { isBrowser, isElectron } from 'react-device-detect';

class Settings extends Component {
    state = {
        appversion: '1.0.5',
        year: 1900
    }
    componentDidMount = async () => {
        scrollTop('SettingDiv');

        // let _y = getPastThreeYearsArr();
        let _d = new Date();
        let _y = _d.getFullYear();

        const { mcid, key } = this.props.auth_feedback;
        this.props.getUserDetails(mcid, key, deviceData(this.props.location, 'navigate'))

        await this.props.getDecks({ mcid: mcid, key: key });

        await this.setState({ 
            ...this.state, 
            year: _y,
        }); 

        return this.props.updateHeaderInfo({
            route:"/settings", 
            name: "App Details", 
            iconTwo: 'menu', 
            iconOne: 'home',
            color: "#00567a"
        });
    };
    
    mapSASPFacultyLinks = () => {
        const arr = getPastThreeYearsArr();

        return arr.map((year) => {
            return (
                <li>
                    <a onClick={remoteURL(getSASPFacultyURI(year))}>
                        View SASP {year} Faculty and Disclosures
                    </a>
                </li>
            );
        });

    }

    render() {
        const { mcid, key } = this.props.auth_feedback;
        return (
            <>
                <div className="aua-overflow anchor" style={setContainer(isBrowser)} id="SettingDiv">
                    <Typography className="homeDividerText">About</Typography>

                    <div className="padding-top-16 padding-bottom-24">
                        <div className="lineHeight-16667">App Version: {APPVERSION}</div>
                    </div>
                
                    <Typography className="homeDividerText" >Contact Information</Typography>

                    <div className="padding-top-16 padding-bottom-24">
                        <div className="lineHeight-16667">
                            If you have any questions please contact the Office of Education at <a href="mailto:education@auanet.org?subject=SASP%20Comment" target="_new">education@auanet.org</a>.
                        </div>
                    </div>

                    <Typography className="homeDividerText" >Notice</Typography>

                    <div className="padding-top-16 padding-bottom-24">
                        <p>
                            You are prohibited from using or uploading content you accessed through this website into external applications, bots, software, or websites, including those using artificial intelligence technologies and infrastructure, including deep learning, machine learning and large language models and generative AI.
                        </p>
                    </div>

                    <div style={{ padding: "8px 0 16px"}} >
                        <SaspButton
                            className="text-white margin-right-8"
                            onClick={() => this.props.deRegister(mcid, key)}
                        >
                            Deregister
                        </SaspButton>
                    </div>          
                
                    <CopyrightWidget 
                        begin={2012}
                        year={getThisYear()}
                        textAlign={'center'}
                        className=" margin-top-48 padding-top-8 padding-bottom-8 padding-left-16 padding-right-16"
                    />
                </div>
            </>
        );
    }
}

const logout = state => {
}

const mapStateToProps = state => {
    const { auth_feedback, user_details, cme_confirmations } = state.auth;
    const { headerText, iconOne, iconTwo } = state.style;
    const { deckList } = state.decks;

    const logout = () => {
    }

    return {
        headerText,
        iconOne,
        iconTwo,
        deckList,
        auth_feedback,
        user_details,
        logout,
        cme_confirmations
    };
};

const SettingsScreen = connect(mapStateToProps, { updateHeaderInfo, getDecks, deRegister, getUserDetails })(
    Settings
);

export { SettingsScreen };
